'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['t', 's', 'm', 'h', 'd'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/duration/durationUnits.js
// module id = 271
// module chunks = 0